import React, {useCallback, useEffect, useState} from 'react';
import {fetchVorgesetzterUserDataSource, switchVorgesetzterUserHandler} from 'module/SessionInfo/api/SwitchVorgesetzterUserAPI';
import {doAfterNextSessionInfoRefreshDone, forceRefreshSessionInfo} from 'module/SessionInfo/api/SessionInfoAPI';
import {VorgztUserTO} from 'generated/JavaTO'
import {SlctOption} from 'module/Slct/type/SlctType'
import {SetCb} from 'type/SetCb'
import {filterOptionsSlct, filterOptionsSlctNoValue} from 'module/Slct/util/filterOptionsSlct'
import {SlctLabelOnly} from 'module/Slct/component/SlctLabelOnly'

const mapToOption = (d: VorgztUserTO) => ({value: d.id, label: d.displayName})

interface Props {
	vorgesetzterUser: VorgztUserTO | null
}

export const VorgesetzterUserSelect = React.memo(({vorgesetzterUser}: Props) => {
	const [loading, setLoading] = useState(false);
	const [options, setOptions] = useState<SlctOption<void, string>[]>([]);
	useEffect(() => {
		fetchVorgesetzterUserDataSource()
			.then(({data}) =>
				setOptions(data.map(mapToOption)),
			)
	}, [])
	const onChange: SetCb<SlctOption<VorgztUserTO, string>> = useCallback((obj) => {
		const req = switchVorgesetzterUserHandler(obj?.value || '')
		setLoading(true)
		req.then(() => {
			doAfterNextSessionInfoRefreshDone(() => setLoading(false))
			forceRefreshSessionInfo()
		})
	}, [])
	return <SlctLabelOnly
		value={vorgesetzterUser?.id}
		options={options}
		onChange={onChange}
		loading={loading}
		filterOptions={filterOptionsSlctNoValue}
	/>
})